import React from 'react';
import i18next from 'i18next';
import BtnGroup from '../../BtnGroup/BtnGroup';
import Button from '../../Button/Button';

export default class MarketsFilter extends React.PureComponent {
  render() {
    const { filters, activeFilter, onChange } = this.props;

    return (
      <div className="markets-filter">
        <BtnGroup>
          <Button
            active={!activeFilter}
            onClick={onChange.bind(null, null)}
            defaultStyles={true}
          >
            {i18next.t('filter.all')}
          </Button>
          {filters.map((f) => (
            <Button
              active={f === activeFilter}
              onClick={onChange.bind(null, f)}
              defaultStyles={true}
              key={f}
            >
              {f}
            </Button>
          ))}
        </BtnGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EsportsGame/MarketsFilter/MarketsFilter.jsx